import React from 'react';
import './designs.css';
import winkapp from '../assets/image.png';
import sukigoapp from '../assets/image2.png';
import tutorial_y1 from '../assets/image3.png';
import tutorial_y2 from '../assets/image7.png';
import '@fortawesome/fontawesome-free/css/all.min.css';


export default function designs() {

    const projectsData = [
        {
          
          description: 'Developed WINK-Secure-Transactions-and-Chat-with-Friends Mobile App.This app hepls users to both chat with friends and do the paymnent transaction using this mobile app eaily. ',
          img: winkapp, 
          tools: ['Figma', 'Photoshop','Mockflow'],
          link: 'https://www.behance.net/gallery/210658407/WINK-Secure-Transactions-and-Chat-with-Friends'
        },
        {
          description: 'Sukigo-Japanese Learning App Design.Students who are learning Japanese Language have to install more apps to learn japanese as listning, do activities papers etc. but this app helps all in one app.',
          img: sukigoapp,
          tools: ['Figma', 'Mockflow',],
          link :'https://www.behance.net/gallery/210747049/Sukigo-Japanese-Learning-Through-Intuitive-Design'
        },
        {
          description: '3D Icon - Create account page design tutorial - This tutorial Focused on 3D modeling, correct HCI thories, icon handling and typography handling and cilour theories.',
          img: tutorial_y1,
          tools: ['Figma', 'Mockflow',],
          link :'https://www.behance.net/gallery/210378023/3D-Icon-Create-account-page-design-tutorial/modules/1195550091'

        },
        {
          description: 'NFT Project Design AdomicArts completed full tutorial. This design tuorial focused on uses of figma and basics theories of UI UX design concept designning.',
          img: tutorial_y2,
          tools: ['Figma', 'Mockflow',],
          link : 'https://www.behance.net/gallery/210377565/NFT-Project-Design-AdomicArts-Tutorial/modules/1195547405'
        },
        
        
      ];
  return (
    <div>
         <div className="projects-container">
      <div className="projects-grid">
        {projectsData.map((project, index) => (
          <div key={index} className="project-card">
            {/* <img src={project.img} alt={`${"Project visual"} thumbnail`} className="project-image" /> */}
            <img src={project.img} alt="Project visual" className="project-image" />
        
           
            <h3>{project.title}</h3>
            <a href={project.link} target="_blank" rel="noopener noreferrer" className="see-more-link"><i className="fa-solid fa-square-up-right"/></a> 
            <p>{project.description}</p>
           
            <div className="project-tools">
            <h4>Tools & Technologies:</h4>
              <ul>
                {project.tools.map((tool, i) => (
                  <li key={i}>{tool}</li> 
                ))}
              </ul>
              
            </div>
    
          </div>
        ))}
      </div>
    </div>
    </div>
  )
}
